(function(){
  var K='pp_wishlist';
  function get(){try{return JSON.parse(localStorage.getItem(K)||'[]')}catch(e){return[]}}
  function set(l){localStorage.setItem(K,JSON.stringify(l))}
  function has(id){return get().some(function(i){return String(i.id)===String(id)})}
  function toggle(btn){
    var id=btn.dataset.ppWlId;
    var l=get();
    var idx=l.findIndex(function(i){return String(i.id)===String(id)});
    if(idx>-1){l.splice(idx,1)}else{l.push({id:id,title:btn.dataset.ppWlTitle,url:btn.dataset.ppWlUrl,image:btn.dataset.ppWlImage,price:btn.dataset.ppWlPrice})}
    set(l);mark(btn,has(id));
  }
  function mark(btn,on){btn.classList.toggle('pp-wl-active',on);btn.setAttribute('aria-label',on?'Remove from wishlist':'Add to wishlist')}
  function init(){
    document.querySelectorAll('.pp-wl-btn-icon').forEach(function(btn){
      mark(btn,has(btn.dataset.ppWlId));
      btn.addEventListener('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        toggle(btn);
        init();
      });
    });
  }
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:reorder',init);
  window.addEventListener('load',function(){setTimeout(init,500);setTimeout(init,1500)});
})();